// Single source of truth for agenda session-track colors. Kept in sync with the
// --type-* custom properties in App.css. Phase 0 uses one AA-safe value per
// track (legible as both the 4px rail and the chip text); Phase 3 splits
// rail / text / tint per the IHES Design System.
export const TYPE_HEX = {
  meal:     '#A45600',
  panel:    '#006020',
  keynote:  '#101080',
  insights: '#1A6E35',
  social:   '#0E1A14',
  golf:     '#3C5B8C',
  break:    '#5C655F',
  general:  '#3D4A6B',
};
